import { curry, pipe, split, join } from 'lodash/fp';
export var replaceAll = curry(function (from, to, text) {
  return pipe([split(from), join(to)])(text);
});
export default replaceAll;